import { Select, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { getRequest } from '../../utils/RequestActions';
import { getImage, getTranslated, parseRefAPI } from '../../utils/CommonUtils';
import { applyROAccess, validateMandatory } from '../../utils/ValidationUtils';
import { useSelector } from 'react-redux';

const ComboBoxField = (props) => {

    const [loading, setLoader] = useState(false)
    const [enumList, setEnumList] = useState([])
    const [value, setValue] = useState(null)
    const [status, setStatus] = useState()
    const [readOnly, setReadOnly] = useState(false)
    const dict = useSelector(state => state.common.dict)

    useEffect(() => {
        if (value === null && props.value === undefined) {
            setValue(props.defaultValue)
            props.handleSchemaDataChange && props.handleSchemaDataChange(props, props.defaultValue)
        } else {
            setValue(props.value)
        }
    }, [props.value, props.defaultValue])

    useEffect(() => {
        setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
    }, [props.access, props.actionMode, props.isReadOnly])

    useEffect(() => {
        if (props.validateState && !validateMandatory(props.mandatory, value)) {
            setStatus("error")
        } else
            setStatus("")
    }, [props.validateState])

    useEffect(() => {
        const tempEnums = props.enum?.map(option => {
            return {
                ...option,
                label: getTranslated(dict, option.label)
            }
        })
        setEnumList(tempEnums)
    }, [props.enum, dict])

    useEffect(() => {
        props.refApi?.apiurl && handleRefApi(props.refApi.apiurl)
    }, [props.refApi?.apiurl])

    const handleSelect = (value) => {
        if (!readOnly) {
            setStatus("")
            setValue(value)
            props.handleSelect && props.handleSelect(value)
            props.handleSchemaDataChange && props.handleSchemaDataChange(props,value)
        }
    }

    const handleBlur = () => {
        props.handleBlur && props.handleBlur(value, props.id)
    }

    const handleClear = (value) => {
        if (!readOnly) {
            if (!validateMandatory(props.mandatory, value)) setStatus("error")

            setValue(value)
            props.handleSelect && props.handleSelect(value)
        }
    }

    const handleOpen = (open) => {
        //For getting enums dynamically from api
        if (open && props?.refApi?.apiurl && !enumList?.length) {
            // handleRefApi()
        }
    }

    const handleRefApi = (apiURL) => {
        setLoader(true)
        const request = {
            url: parseRefAPI(apiURL)
        }
        getRequest(request, (response, status) => {
            setLoader(false)
            if (status) {
                setEnumList(response)
            } else {
                setEnumList([])
            }
        })
    }

    return <div className={`attr-wrap ${readOnly ? "read-only" : ""}`}>
        <Select
            showSearch
            className={`${props.className} ${props.parentClassName}`}
            popupClassName={props.popupClassName || ""}
            value={value}
            placeholder={getTranslated(dict, props.help)}
            status={status}
            readOnly={readOnly}
            optionFilterProp="children"
            mode={props.mode || ""}
            maxTagCount={props.maxTagCount || ""}
            onSelect={handleSelect}
            onBlur={() => handleBlur()}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={enumList}
            loading={loading}
            onDropdownVisibleChange={(open) => handleOpen(open)}
            allowClear={props.allowClear || false}
            onClear={handleClear}
            onClick={props.onClick}
            tabIndex={readOnly && -1}
        />
        {(props.iconName) ? <Tooltip title={getTranslated(dict, props.iconHelp)}>
            <img src={getImage(props.iconName)} className="attr-info-img" alt="info" style={{ height: props.iconHeight || "1.3em", margin: "auto" }} />
        </Tooltip> : <></>}
    </div>
}

export default ComboBoxField;